    import React, { useState } from 'react';
    import { Button, TextField, Box, Typography, Card, CardContent, IconButton, Grid } from '@mui/material';
    import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
    import apiInstance from '../../../services/ServiceApi';
    import ToastMessagge from '../../../components/utilities/ToastMessage';
    import Loader from '../../../components/Loader';

    function formatDate(date) {
        const year = date.getFullYear();
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const day = ('0' + date.getDate()).slice(-2);
        return `${year}-${month}-${day}`;
    }

    const ClienteAdd = ({ autotipificar = false ,onChildCallback }) => {
        const today = new Date();
        const [loading, setLoading] = useState(false);
        let userString = localStorage.getItem("user");
        let user = JSON.parse(userString);
        const [toastProps, setToastProps] = useState({
            open: false,
            msg: '',
            severity: 'info'
        });
        
        const formattedToday = formatDate(today);

        const [formData, setFormData] = useState({
            autotipificar: autotipificar,
            codigo_usuario:user.username,
            nombre: '',
            apellido_materno: '',
            apellido_paterno: '',
            dni: '',
            edad: '',
            numero_celular: '',
            direccion: '',
            correo: '',
            fecha_nacimiento: formattedToday,
            competitividad: '',
            TIPO_CAMPANA: '',
            PRODUCTO: '',
            MARCA_LABORAL: '',
            PRINCIPALIDAD:'',
            BASE:''
        });
    
        const handleChange = (e) => {
            setFormData({
                ...formData,
                [e.target.name]: e.target.value,
            });
        };

        const handleSubmit = async (event) => {
            event.preventDefault();
            setLoading(true);
            try {
                const response = await apiInstance.post('clienteadd/', { data: formData });
             
                onChildCallback(response.data); 
            } catch (error) {
                console.log(error)
                setToastProps({ open: true, msg: error.data, severity: 'error' });
            }
            finally {
                setLoading(false); // Detener el indicador de carga
            }
        };
        
        const fieldCliente = [
            { name: 'nombre', label: 'Nombres' },
            { name: 'apellido_paterno', label: 'Apellido Paterno' },
            { name: 'apellido_materno', label: 'Apellido Materno' },
            {
                name: 'dni',
                label: 'DNI',
                required: true,  
                helperText: formData.dni ? '' : 'El DNI es obligatorio'
            },
            { name: 'edad', label: 'Edad' },
            { name: 'numero_celular', label: 'Celular' },
            { name: 'direccion', label: 'Direccion' },
            { name: 'correo', label: 'Correo' },
        ];
        
        const fieldCuenta = [
            { name: 'competitividad', label: 'Competitividad' },
            { name: 'TIPO_CAMPANA', label: 'Tipo Campaña' },
            { name: 'PRODUCTO', label: 'Producto' },
            { name: 'MARCA_LABORAL', label: 'Marca Laboral' },
            { name: 'PRINCIPALIDAD', label: 'PRINCIPALIDAD' },
            { name: 'BASE', label: 'BASE' },
            
        ];
    

        return (
            <Box component="form" sx={{ mt: 3 }} onSubmit={handleSubmit}>
            {loading && <Loader /> }
                <Typography variant="h6">Agregar Cliente</Typography>
                <Card variant="outlined" sx={{ mt: 2, p: 2 }}>
                    <CardContent>
                        <Typography variant="subtitle1">Datos Personales</Typography>
                        <Grid container spacing={2}>
                            {fieldCliente.map(field => (
                                <Grid item xs={12} sm={4} key={field.name}>
                                <TextField
                                    key={field.name}
                                    fullWidth
                                    margin="normal"
                                    name={field.name}
                                    label={field.label}
                                    variant="outlined"
                                    value={formData[field.name]}
                                    onChange={handleChange}
                                    helperText={field.helperText} 
                                    required={field.required}     
                                />
                                </Grid>
                            ))}
                             <Grid item xs={12} sm={4}>

                            <TextField
                                fullWidth
                                margin="normal"
                                label="Fecha de Nacimiento"
                                type="date"
                                name="fecha_nacimiento"
                                value={formData.fecha_nacimiento}
                                onChange={handleChange}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                required
                            />
                            </Grid>
                        </Grid>

                    </CardContent>
                </Card>
                <Card variant="outlined" sx={{ mt: 2, p: 2 }}>
                    <CardContent>
                        <Typography variant="subtitle1">Cuentas</Typography>
                        <Grid container spacing={2}>

                            {fieldCuenta.map(field => (
                                <Grid item xs={12} sm={4}>

                                <TextField
                                    key={field.name}
                                    fullWidth
                                    margin="normal"
                                    name={field.name}
                                    label={field.label}
                                    variant="outlined"
                                    value={formData[field.name]}
                                    onChange={handleChange}
                                    InputProps={{
                                        endAdornment: (
                                            <IconButton edge="end">
                                                <InfoOutlinedIcon fontSize="small" />
                                            </IconButton>
                                        ),
                                    }}
                                />
                                </Grid>
                            ))}
                            </Grid>

                    </CardContent>
                </Card>
                <Button type="submit" fullWidth variant="contained" color="primary" sx={{ mt: 3 }}>
                    Agregar
                </Button>
                <ToastMessagge 
                    open={toastProps.open} 
                    msg={toastProps.msg} 
                    severity={toastProps.severity} 
                    onClose={() => setToastProps(prev => ({ ...prev, open: false }))} 
                />

            </Box>
        );
    };

    export default ClienteAdd;
